import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCompanyCreateForm from "./ui/shopping-company-create-form";

export default function ShoppingCompanyCreatePage() {
  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Companies", href: "/admin/shopping-companies" },
          {
            label: "Create",
            href: "/admin/shopping-companies/create",
            active: true,
          },
        ]}
      />
      <ShoppingCompanyCreateForm />
    </main>
  );
}
